// Function to calculate distance between two points using the Haversine formula
export function calculateDistance(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number {
  // Convert degrees to radians
  const toRadians = (degrees: number) => degrees * Math.PI / 180;

  const R = 3958.8; // Earth's radius in miles
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;

  // Convert to feet (1 mile = 5280 feet)
  return distance * 5280;
}

// Function to check if an incident is within range of any camera
export function isWithinRangeOfCamera(
  incidentLat: number,
  incidentLng: number,
  cameras: { lat: string, lon: string }[],
  rangeInFeet: number = 1000
): boolean {
  // Check distance to each camera
  for (const camera of cameras) {
    const cameraLat = parseFloat(camera.lat);
    const cameraLng = parseFloat(camera.lon);

    const distance = calculateDistance(
      incidentLat,
      incidentLng,
      cameraLat,
      cameraLng
    );

    if (distance <= rangeInFeet) {
      return true;
    }
  }

  return false;
}

// Function to extract lat/lng from an incident's coordinates
export function extractCoordinatesFromIncident(incident: any): { lat: number, lng: number } | null {
  if (!incident.intersection_point) return null;

  const point = incident.intersection_point;

  if (point.type === 'Point' && Array.isArray(point.coordinates) && point.coordinates.length === 2) {
    // GeoJSON format: [longitude, latitude]
    return {
      lng: point.coordinates[0],
      lat: point.coordinates[1]
    };
  }

  return null;
} 